var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col-content"},[_vm._t("default"),_c('div',{staticClass:"flex-1"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }